import { render, staticRenderFns } from "./lender.vue?vue&type=template&id=a64ea620"
import script from "./lender.vue?vue&type=script&lang=js"
export * from "./lender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports